import { CAMPAIGN_OFFERS } from "../enum/campaignOffers";

// Encontra a campanha (PREZAO_SHOPEE, PREZAO_KWAI, ...) cujo plan_base_offers contém o id do plano
const getActiveCampaign = planBaseOffer =>
  Object.values(CAMPAIGN_OFFERS).find(campaign =>
    campaign.plan_base_offer.includes(planBaseOffer)
  ) || null;

// Filtra os rechargeValues disponíveis para a campanha do plano, ordenados do maior para o menor
const getCampaignRechargeValues = (planBaseOffer, rechargeValues = []) => {
  const campaign = getActiveCampaign(planBaseOffer);
  if (!campaign) return [];

  return rechargeValues
    .filter(rv => campaign.rechargeValues[rv.value] !== undefined)
    .sort((a, b) => b.value - a.value);
};

const getCampaignValueConfig = (planBaseOffer, value) => {
  const campaign = getActiveCampaign(planBaseOffer);
  return campaign?.rechargeValues?.[value] || null;
};

const getCampaignFreedomBonus = (planBaseOffer, value) =>
  getCampaignValueConfig(planBaseOffer, value)?.freedomBonus || "";

const getTraitValue = (traits, name) => traits?.[name]?.value;

const isEligibleForRechargeValueSelect = traits => {
  const scheduledStatus = getTraitValue(traits, "scheduled_topup_status");
  const planBaseOffer = getTraitValue(traits, "plan_base_offer");

  const isScheduledInactive = !scheduledStatus || scheduledStatus === "canceled";
  const hasActiveCampaign = !!getActiveCampaign(planBaseOffer);

  return isScheduledInactive && hasActiveCampaign;
};

export {
  getActiveCampaign,
  getCampaignRechargeValues,
  getCampaignValueConfig,
  getCampaignFreedomBonus,
  isEligibleForRechargeValueSelect,
};
